import * as React from 'react';
import HineMMForm from './HineMM';
import RULMForm from './RULM';
import CHOPINTENDForm from './CHOPINTEND';
import HFMSEForm from './HFMSE';
import MWTForm from './MWT';
import NSAAForm from './NSAA';
import MFMForm from './MFM';
import type { TMotorDocumentType } from 'Routes/Motor/utils';
import { formDataByType } from 'Utility/documentHandling';

const MotorForm = ({ formData, document, editing, viewing = false }: IOwnProps): React.JSX.Element | null => {
  switch (document._type) {
    case 'hine_mm':
      return <HineMMForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'rulm':
      return <RULMForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'chop_intend':
      return <CHOPINTENDForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'hfms_e':
      return <HFMSEForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'mwt':
      return <MWTForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'nsaa':
      return <NSAAForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'mfm':
      return <MFMForm formData={formDataByType(formData, document)} viewing={viewing} editing={editing} />;
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<TMotorDocumentType>>;
  document: IDocumentWithTypeV2<TMotorDocumentType>;
  editing?: string;
  viewing?: boolean;
}

export default MotorForm;
